import { createContext, useContext } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { type UIConfig } from '../../../types';

const initialState: UIConfig = {
	fullScreen: false,
	mode: 'sidebar',
	externalEmbed: false,
	elements: {
		closeButton: true,
		newChatButton: true,
		fullscreenButton: true,
		createAgentButton: true,
		browseAgentsButton: true,
		agentsMenu: true,
		navbar: true,
		stagingAreaEnabled: false,
	},
};

export const uiConfigDefaults = initialState;

const uiConfig = createContext<UIConfig>(initialState);
export const UIConfigProvider = uiConfig.Provider;
export const useUIConfig = () => useContext(uiConfig);

export const createUIConfig = (config?: Partial<UIConfig>): UIConfig => {
	// Allow fullscreen override for branch deploy testing purposes
	const processedConfig =
		localStorage.getItem('DEBUG_rovo_chat_fullscreen') === 'true' &&
		fg('rovo_chat_show_local_frontend_components')
			? {
					...config,
					fullScreen: true,
				}
			: config;

	return {
		...initialState,
		...processedConfig,
		elements: {
			...initialState.elements,
			...processedConfig?.elements,
		},
	};
};
